/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Patch drawer inner elements to fire 'animationend' on 'transitionend'
  // so the theme's waitForAnimationEnd() resolves for CSS transitions too
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-drawer-inner]').forEach(function(el) {
      el.addEventListener('transitionend', function(e) {
        if (e.target !== el) return;
        el.dispatchEvent(new Event('animationend', { bubbles: false }));
      });
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
